import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

const STORAGE_KEY = '__app_logs__';
const MAX_ENTRIES = 200;

// Type exporté pour être partagé avec le composant
export interface LogEntry {
  level: string;
  message: string;
  time: Date;
  context?: unknown; // champ optionnel aligné avec le template
}

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private logs: LogEntry[] = this.loadFromStorage();

  // Subject qui notifie les abonnés à chaque ajout ou clear
  private logs$ = new Subject<void>();
  readonly changes$: Observable<void> = this.logs$.asObservable();

  log(message: string, context?: unknown)   { this.add('LOG',   message, context); }
  warn(message: string, context?: unknown)  { this.add('WARN',  message, context); }
  error(message: string, context?: unknown) { this.add('ERROR', message, context); }

  private add(level: string, message: string, context?: unknown) {
    this.logs.push({ level, message, time: new Date(), context });
    if (this.logs.length > MAX_ENTRIES) this.logs.shift();

    if (level === 'ERROR') console.error(message, context);
    else if (level === 'WARN') console.warn(message, context);
    else console.log(message, context);

    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(this.logs)); } catch {}

    // Notifie les abonnés
    this.logs$.next();
  }

  getLogs(): LogEntry[] { return this.logs; }

  clear() {
    this.logs = [];
    localStorage.removeItem(STORAGE_KEY);
    this.logs$.next();
  }

  private loadFromStorage(): LogEntry[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      return (JSON.parse(raw) as any[]).map(e => ({ ...e, time: new Date(e.time) }));
    } catch { return []; }
  }
}